<div
  class="group relative flex min-h-[240px] flex-col justify-between overflow-hidden rounded-xl rounded-se-[30px] shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
>
  <div
    class="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-[1.03]"
    [style.backgroundImage]="'url(' + service().image + ')'"
  ></div>
  <div class="absolute inset-0 bg-gradient-to-t from-shl-navy/90 via-shl-navy/50 to-transparent"></div>
  <div class="relative z-10 flex h-full flex-col justify-between p-6 text-white">
    <div
      class="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-white/15 text-white backdrop-blur-sm ring-1 ring-white/20"
    >
      <mat-icon fontSet="material-symbols-outlined" class="text-2xl">{{ service().icon }}</mat-icon>
    </div>
    <div>
      <h3 class="mb-2 text-lg font-bold">{{ service().title | translate }}</h3>
      <p class="text-sm text-blue-100/90 leading-relaxed">
        {{ service().description | translate }}
      </p>
    </div>
  </div>
</div>
